import styled from "styled-components";
import { Typography, TypographyVariant } from "../../../components/ui-kit";
import { CheckGreen } from "../../../components/icons";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 15px;
`;

const CheckWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  background-color: #d2f1ea4b;
  border-radius: 50%;
  width: 26px;
  height: 26px;
`;

const StyledDescription = styled(Typography)`
  margin-top: 0;
`;

interface CheckedItemsProps {
  text: string;
}

const CheckedItems: React.FunctionComponent<CheckedItemsProps> = ({ text }) => {
  return (
    <Wrapper>
      <div>
        <CheckWrapper>
          <CheckGreen />
        </CheckWrapper>
      </div>
      <StyledDescription variant={TypographyVariant.HEADER4}>
        {text}
      </StyledDescription>
    </Wrapper>
  );
};

export default CheckedItems;
